<template>
  <div id="main-content">
    <BaseHeader />
    <div class="hero search-hero" :style="heroStyle">
      <div class="container">
        <div class="row">
          <div class="col-md-12"></div>
        </div>
      </div>
    </div>

    <div class="page-single movie-single movie_single small-page-single">
      <div class="container container-margin">
        <div class="container registering-form">
          <div class="row">
            <div class="col-md-12">
              <!-- Placeholder content until dashboard features are added -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import BaseHeader from '../components/BaseHeader.vue'

const heroStyle = computed(() => ({
  backgroundImage: "url('/static/films/legacy/bg-darker.jpg')",
}))
</script>
